module.exports = __webpack_public_path__ + "static/profile-74b3c10985c86cfc5f5b645fa13013f7.jpg";